import { useContext } from "react";
import FinalSearchSuggestion from "./final/FinalSearchSuggestion";
import InitialSearchSuggestion from "./initial/InitialSearchSuggestion";
import { AppContext } from "@/contexts/appContexts";

const SearchTermsBox = ({
  openSearchTermsRef,
  inputValue,
  products,
  clearSearch,
  redirectToSearch,
  suggestions,
  handleSearch,
  queryID,
}) => {
  const { savedSearchWords } = useContext(AppContext);
  const showSearchTermsBox =
    (inputValue && products?.length > 0) || savedSearchWords?.length > 0;

  if (!showSearchTermsBox) {
    return null;
  }
  return (
    <div
      ref={openSearchTermsRef}
      className={`absolute inset-y-10 z-[999]  w-full start-0`}
    >
      <div className=" bg-white rounded-lg shadow-lg  max-h-[70vh] overflow-y-auto p-2 md:mx-2 red-scrollbar">
        {(!inputValue || !products?.length) && (
          <InitialSearchSuggestion
            redirectToSearch={redirectToSearch}
            savedSearchWords={savedSearchWords}
          />
        )}

        {inputValue && !!products?.length && (
          <FinalSearchSuggestion
            clearSearch={clearSearch}
            products={products}
            inputValue={inputValue}
            redirectToSearch={redirectToSearch}
            suggestions={suggestions}
            handleSearch={handleSearch}
            queryID={queryID}
          />
        )}
      </div>
    </div>
  );
};

export default SearchTermsBox;
